import React from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { USE_FILE_UPLOAD } from 'features'
import { mapLanguageToComponentProps } from 'i18n'
import { Body } from 'components/styled/typography'
import { I18nComponentType } from 'i18n-types'
import { BodyStyle } from 'components/styled/typography/styles'

type CustomSupportType = {
  companyName: string
  type: string
  value: string
}

interface CandidateTutorialProps {
  i18n: I18nComponentType
  className: string
  steps: number[]
  numbers?: boolean
  customSupport?: CustomSupportType
}

const StyledContainer = styled.div`
  row-gap: ${({ theme }) => theme.space.s8};
  margin: ${({ theme }) => theme.space.s16} 0;
  a {
    color: ${({ theme }) => theme.color.primary110};
  }
`

const StyledHeadline = styled(Body)`
  display: inline;
`

const StyledSpan = styled.span`
  ${BodyStyle};
  display: inline;
`

export function CandidateTutorial({
  i18n,
  numbers,
  className,
  steps,
  customSupport,
}: CandidateTutorialProps) {
  const getSupportLink = () => {
    if (customSupport) {
      if (customSupport.type === 'email') {
        return `<a href="mailto:${customSupport.value}">${customSupport.value}</a>`
      }

      if (customSupport.type === 'link') {
        return `<a href="${customSupport.value}" target="_blank" rel="noopener noreferrer">
          ${customSupport.companyName}
        </a>`
      }
    }

    return `<a href="mailto:${i18n.supportLink}">${i18n.supportLink}</a>`
  }

  const getStepContent = (step: number) => {
    const supportLink: string = getSupportLink()
    const languageKeys: any = i18n.modalCandidateInfo

    switch (step) {
      case 0:
        if (USE_FILE_UPLOAD) {
          return languageKeys[step].mobileContent
        }
        return languageKeys[step].content
      case 3:
        if (customSupport) {
          return languageKeys[step].customContent(supportLink)
        }
        return languageKeys[step].content(supportLink)
      default:
        return languageKeys[step].content
    }
  }

  return (
    <div className={`${className} candidate-tutorial`}>
      {steps.map(step => {
        const content = getStepContent(step)
        const indexNumber = numbers ? `${step + 1}. ` : ''

        return (
          <StyledContainer key={i18n.modalCandidateInfo[step].headline}>
            <StyledHeadline fontWeight={600}>
              {indexNumber + i18n.modalCandidateInfo[step].headline}
            </StyledHeadline>
            <StyledSpan
              data-testid="instruction-body"
              dangerouslySetInnerHTML={{ __html: content }}
            />
          </StyledContainer>
        )
      })}
    </div>
  )
}

export default connect(mapLanguageToComponentProps())(CandidateTutorial)
